import { Entry } from '../Entry'

export function Entry20260629() {
  return (
    <Entry title="2026 Jun 29 - v3.11.15">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/25912/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
